import {
  SET_GUK_SERVERS_LOADING,
  SET_GUK_SERVERS_DATA
} from "./types";
import { api } from "../App";

export const getGukServers = () => async (dispatch) => {
  try {
    dispatch({ type: SET_GUK_SERVERS_LOADING, payload: true });
    const { data } = await api.get('/zabbix_lms_cons/servers');
    dispatch({ type: SET_GUK_SERVERS_DATA, payload: data.servers || data });
  } catch (ERR) {
    console.error('Ошибка при загрузке серверов ГУК:', ERR);
  } finally {
    dispatch({ type: SET_GUK_SERVERS_LOADING, payload: false });
  }
}
